// This file is part of sisdai-proyecto-base.
//
//   sisdai-proyecto-base is free software: you can redistribute it and/or modify
//   it under the terms of the GNU Lesser General Public License as published by the
//   Free Software Foundation, either version 3 of the License, or
//   (at your option) any later version.
//
//   sisdai-proyecto-base is distributed in the hope that it will be useful,
//   but WITHOUT ANY WARRANTY; without even the implied warranty of
//   MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General
//   Public License for more details.
//
//   You should have received a copy of the GNU Lesser General Public License along
//   with sisdai-proyecto-base. If not, see <https://www.gnu.org/licenses/>.

import Vue from 'vue'
import VueRouter from 'vue-router'
import PaginaInicio from '../views/PaginaInicio.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: PaginaInicio,
    // children: [
    //   {
    //     path: '',
    //     name: 'Inicio',
    //     component: () => import('@/views/mapas/PaginaMapaAsentamientos.vue'),
    //   },
    //   {
    //     path: 'mapas-poblacion',
    //     name: 'Mapas Población',
    //     component: () => import('@/views/mapas/PaginaMapasPoblacion.vue'),
    //   },
    // ],
  },
  // {
  //   path: '/catalogo',
  //   name: 'Catálogo',
  //   component: () => import('@/views/PaginaCatalogo.vue'),
  // },
  // {
  //   path: '/pueblos',
  //   name: 'Pueblos',
  //   component: () => import('@/views/PaginaPueblos.vue'),
  // },
  // {
  //   path: '/pueblo/:idPueblo',
  //   component: () => import('../views/PaginaPueblo.vue'),
  //   props: true,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Pueblo - Introducción',
  //       component: () => import('@/views/pueblo/PaginaIntroduccion.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'datos_generales',
  //       name: 'Pueblo - Datos generales',
  //       component: () => import('@/views/pueblo/PaginaDatosGenerales.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'territorio',
  //       name: 'Pueblo - Territorio',
  //       component: () => import('@/views/pueblo/PaginaTerritorio.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'politica',
  //       name: 'Pueblo - Organización política',
  //       component: () => import('@/views/pueblo/PaginaPolitica.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'sociedad',
  //       name: 'Pueblo - Sociedad',
  //       component: () => import('@/views/pueblo/PaginaSociedad.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'cultura',
  //       name: 'Pueblo - Cultura',
  //       component: () => import('@/views/pueblo/PaginaCultura.vue'),
  //       props: true,
  //     },
  //     {
  //       path: 'economia',
  //       name: 'Pueblo - Economía',
  //       component: () => import('@/views/pueblo/PaginaEconomia.vue'),
  //       props: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/politica',
  //   name: 'Política',
  //   component: () => import('@/views/PaginaPolitica.vue'),
  // },
  {
    path: '/metodologia',
    name: 'Metodología',
    component: () => import('@/views/PaginaMetodologia.vue'),
  },
  {
    path: '/glosario',
    name: 'Glosario',
    component: () => import('@/views/PaginaGlosario.vue'),
  },
  {
    path: '/creditos',
    name: 'Créditos',
    component: () => import('@/views/PaginaCreditos.vue'),
  },
  {
    path: '/creditos/:id',
    name: 'Creditos',
    component: () => import('../views/PaginaDetalleInvestigadorx.vue'),
    props: true,
  },
  {
    path: '**',
    name: 'pagina-no-encontrada',
    component: () => import('@/views/ErrorPaginaNoEncontrada.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    if (from.name === 'Mapas Población' && to.name === 'Inicio') {
      // Cuando navegas en los mapas del inicio
      return null
    }
    if (from.name === 'Inicio' && to.name === 'Mapas Población') {
      // Cuando navegas en los mapas del inicio
      return null
    }
    if (from.name !== 'Inicio' && to.name === 'Inicio') {
      // Cuando vas a Inicio desde otra sección
      return { x: 0, y: 0, behavior: 'smooth' }
    }
    if (from.name !== 'Inicio' && to.name === 'Glosario') {
      // Cuando vas a Glosario desde otra sección
      document.querySelector('#app').scrollIntoView()
    }
    if (from.name === 'Pueblos' && to.name === 'Pueblo') {
      // Cuando vas a un pueblo en específico
      document.querySelector('#app').scrollIntoView()
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  },
})

// Muestra el título de la página dependiendo de las vistas
router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} | ${to.name}`
  next()
})

export default router
